import { EmptyBlock } from '@lmt/unicorn-shared/app/components/patients/profile/overview/components/EmptyBlock';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import clsx from 'clsx';
import React from 'react';
import { CurrentVisitInfo, CurrentVisitItem } from './CurrentVisitItem';

import styles from './CurrentVisitsPanel.module.scss';

export interface CurrentVisitsPanelProps {
  currentVisits: CurrentVisitInfo[];
  openPatientTab: (patientId: number) => void;
  openCaseVisitTab: (
    patientId: number,
    caseId: number,
    visitId: number,
  ) => void;
}

export const CurrentVisitsPanel: React.FC<CurrentVisitsPanelProps> = (
  props,
) => {
  const { currentVisits, openPatientTab } = props;
  const i18next = useScopedTranslation('dashboard.current_visits');

  if (currentVisits.length === 0) {
    return (
      <div
        className={clsx(styles.container, styles.emptyBlockContainer)}
        data-test-id="current-visits-block"
      >
        <EmptyBlock title={i18next.t('title')} text={i18next.t('empty')} />
      </div>
    );
  }

  const hasPlaceColumn = currentVisits.some((visit) => visit.room);

  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <div className={styles.header}>
          <div className={styles.title}>{i18next.t('title')}</div>
        </div>
        <table className={styles.visitsTable}>
          <tbody>
            {currentVisits.map((visit) => {
              return (
                <CurrentVisitItem
                  key={visit.id}
                  visit={visit}
                  hasPlaceColumn={hasPlaceColumn}
                  openCaseVisitTab={props.openCaseVisitTab}
                  openPatientTab={openPatientTab}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
